import Image from 'components/ui/Image';
import Icon from '../Icon';
import styles from './Testimonial.module.scss';
import type { IBlockTestimonialFields } from 'types/contentful/generated';

const Testimonial = ({
  image,
  location,
  name,
  testimonial,
  treatment,
}: IBlockTestimonialFields): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <Image
          // eslint-disable-next-line
          // @ts-ignore
          src={image?.file?.url || image?.url}
          height={156}
          width={156}
          alt={name || ''}
          contentful
        />
      </div>
      <Icon type="QuoteAlternate" className={styles.quote} color="#E8EEEF" />
      <div className={styles.content}>
        <p>“{testimonial}”</p>
        <p className={styles.name}>{name}</p>
        <p className={styles.location}>
          {location}, {treatment}
        </p>
      </div>
    </div>
  );
};

export default Testimonial;
